import { Typography } from '@provider-portal/design-common/kalep/components';
import { useMediaQuery, useTheme } from '@mui/material';

export interface PageTitleProps {
  title: string;
}

export function PageTitle({ title }: PageTitleProps) {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Typography
      variant={isXs ? 'heading-xs-accent' : 'heading-m-accent'}
      sx={{
        mb: '12px',
      }}
    >
      {title}
    </Typography>
  );
}
